import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeftBannerComponent } from './left-banner/left-banner.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { HomepageBannerComponent } from './homepage-banner/homepage-banner.component';
import { CmsCommonModule } from '../cms-common/cms-common.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomepageUkBannerComponent } from './homepage-uk-banner/homepage-uk-banner.component';
import { RouterModule } from '@angular/router';
import { HomepageUkWhyfluComponent } from './homepage-uk-whyflu/homepage-uk-whyflu.component';



@NgModule({
  declarations: [
    LeftBannerComponent,
    HomepageBannerComponent,
    HomepageUkBannerComponent,
    HomepageUkWhyfluComponent,
    
  ],
  imports: [
    CommonModule,
    CmsCommonModule,
    FormsModule,
    ReactiveFormsModule,
    I18nModule,
    RouterModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SeqirusBackgroundBannerComponent: {
          component: HomepageBannerComponent
        },
        SeqirusLeftBannerComponent: {
          component: LeftBannerComponent
        },
        SeqirusHomePageBannerComponent: {
          component: HomepageUkBannerComponent
        },
        SeqirusWhyFluDetail: {
          component: HomepageUkWhyfluComponent
        }
      }
    } as CmsConfig)
  ]
})
export class BannerModule { }
